export const button = {
  root: {
    borderRadius: '1rem',
  },
  css: ({ dt }: any) => `
    .p-button {
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
  `,
};
